import { useEffect } from 'react';
import { base64ToBlob, downloadAsFile } from 'utilities/APIRequestHelper';
import { CONTENT_TYPE_PDF, PDF, BLOB_CONTENT_TYPE_PDF } from 'constants/APIRequestContants.js';

export const useFileDownload = ({
    pdfDownloadLink,
    pdfDownloadLinkName,
    showPreLoader,
    hidePreLoader,
    clearPdf,
    getPdfMerge,
}) => {
    const getLinkName = () => {
        if (pdfDownloadLinkName) return `${pdfDownloadLinkName}${PDF}`;

        return `${Math.floor(Date.now() / 1000)}${PDF}`;
    };

    const getBlob = () => base64ToBlob(`${BLOB_CONTENT_TYPE_PDF}${pdfDownloadLink}`);

    const handleFileDownload = () => {
        downloadAsFile(getBlob(), CONTENT_TYPE_PDF, getLinkName());
        hidePreLoader();
    };

    const handleOnStartFileDownload = precontractualLinks => {
        showPreLoader();
        getPdfMerge(precontractualLinks);
    };

    useEffect(() => {
        pdfDownloadLink && handleFileDownload();
    }, [pdfDownloadLink]);

    useEffect(() => {
        return () => {
            clearPdf();
        };
    }, []);

    return { handleOnStartFileDownload };
};
